import "./EditCompany.html";

import type { IComponentOptions, IControllerConstructor, Injectable } from "angular";
import { module } from "angular";
import EditCompanyComponentController from "./EditCompanyComponentController";

export default class EditCompanyComponent implements IComponentOptions {
    public bindings: any;

    public controller: Injectable<IControllerConstructor>;

    public templateUrl: string;

    constructor() {
        this.bindings = {
            resolve: "<",
        };
        this.controller = EditCompanyComponentController;
        this.templateUrl = "/App/Components/Companies/Edit/EditCompany.html";
    }
}

module("mmManagePortal").component("irEditCompany", new EditCompanyComponent());
